import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {usePengajuanListModel} from "@/stores/models/pengajuan-list-model";

export const usePengajuanListStore  = defineStore(
    'pengajuanListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourcePengajuanList = ref(
            new DataSource({
                requireTotalCount: true,
                store: usePengajuanListModel().pengajuanListCustomStore,
                filter: null,
            })
        );
       
        const loadData = async (filter = null) => {
            isLoading.value = true;
            try {
                dataSourcePengajuanList.value.filter(filter);
                // Reload the DataSource with the new filter
                const result = await dataSourcePengajuanList.value.load();
                return result;
            } catch (error) {
                console.error("Error loading data:", error);
                throw error;
            } finally {
                isLoading.value = false;
            }
        };

        const insertData = async (newItem) => {        
            try {
                console.log("pengajuanListStore insertData 1", newItem);
               
                const result = await dataSourcePengajuanList.value.store().insert(newItem);
                return result;
            } catch (error) {
                console.error("Error inserting data:", error);
                throw error;
            }
        };

        const updateData = async (updatedRows) => {

            const store = dataSourcePengajuanList.value.store();
            try {
                // Create an array of update promises
                const updatePromises = updatedRows.map(row => {
                  return store.update(row.id, row); // Assume `id` is the key field
                });
          
                // Wait for all update operations to complete
               
                const results = await Promise.all(updatePromises);
          
                return results;
              } catch (error) {
                console.error("Error updating data:", error);
                throw error;
              }
        };


        



        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourcePengajuanList.value.reload();
        };

     

        const initialized = ()=>{     
            dataSourcePengajuanList.value.reload();
        };

        return {
           loadData,
           insertData,
           updateData,
            dataSourcePengajuanList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);